import React, { useState, useEffect } from 'react';
import { useRouteMatch, useParams, useHistory } from 'react-router-dom';
import LabelledTextBox from '../../components/LabelledTextBox';
import LabelledTextArea from '../../components/LabelledTextArea';
import LabelledDatePicker from '../../components/LabelledDatePicker';
import LabelledPicker from '../../components/LabelledPicker';
import LabelledCheckBox from '../../components/LabelledCheckBox';
import { getHydrantExerciseEdit, updateHydrantExercise } from '../../services/api';
import { makeHydrantExercise } from '../../models';
import EventEmitter from '../../services/events';

const EditHydrantExercise = ({ onUpdate }) => {
  const [exercise, setExercise] = useState(null);
  const { path, url } = useRouteMatch();
  const { hydrantId, hydrantExerciseId } = useParams();
  const history = useHistory();

  useEffect(() => {
    setupExercise();
  }, [hydrantId, history.location]);

  const setupExercise = async () => {
    const result = await getHydrantExerciseEdit(hydrantExerciseId);
    setExercise(makeHydrantExercise(result));
  };

  const save = async () => {
    try {
      console.log(exercise);
      exercise.validate();
      const result = await updateHydrantExercise(exercise);
      onUpdate(hydrantExerciseId);
      history.replace(`/hydrants/${hydrantId}/hydrantExercise/${exercise.id}`);
    } catch (error) {
      console.log(error);
      if (error.name === 'ValidationError') {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Exercise', body: error.message.split('\n').map((str, idx) => <p key={idx}>{str}</p>) });
      } else {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Exercise', body: 'Unable to save hydrant exercise.' });
      }
    }
  };

  const cancel = async () => {
    history.goBack();
  };

  const onChange = e => {
    const type = e.type;
    let value = e.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      case 'checkbox':
        value = !!value;
        break;
    }
    setExercise(makeHydrantExercise({ ...exercise, [e.name]: value }));
  };

  const onBlur = e => {
    console.log(e.type);
    const type = e.type;
    let value = e.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      case 'checkbox':
        value = !!value;
        break;
    }

    setExercise(makeHydrantExercise({ ...exercise, [e.name]: value }));
  };
  
  return (
    <div>
      <h3>Edit Hydrant Exercise</h3>
      {exercise ? (
        <>
          <div className="details">
            <LabelledDatePicker label="Exercise Date" value={exercise.exerciseDate} name="exerciseDate" onChange={onChange} dateFormat="MM/dd/yyyy h:mm aa" showTimeSelect />
            <LabelledCheckBox label="Manual Entry" value={exercise.manual} name="manual" onChange={onChange} onBlur={onBlur} />
            {exercise.manual && 
            <LabelledPicker label="Difficulty" value={exercise.difficulty} name="difficulty" onChange={onChange} onBlur={onBlur}>
              <option value=""></option>
              <option value="Easy">Easy</option>
              <option value="Medium">Medium</option>
              <option value="Hard">Hard</option>
            </LabelledPicker>}
            <LabelledTextArea label="Comments" value={exercise.comments} name="comments" onChange={onChange} onBlur={onBlur} />
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={cancel}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={save}>Save</button>
          </div>
        </>
      ) : (
        <span className="spinner"></span>
      )}
    </div>
  );
};

export default EditHydrantExercise;
